// src/routes/ProtectedRoutes.js

import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthContext } from '../hooks/useAuth';

const ProtectedRoutes = () => {
	const { isAuthenticated, user, isLoading } = useAuthContext();

	if (isLoading) {
		return <div>Loading...</div>; // Or a loading spinner component
	}

	// Check if the user is authenticated
	if (!isAuthenticated) {
		return <Navigate to="/admin/login" replace />;
	}

	// Get the current path (e.g., /admin/dashboard, /admin/access-management)
	const currentPath = window.location.pathname;

	// Access accessibleRoutes from the user object
	const accessibleRoutes = user?.accessibleRoutes || [];

	// Check if the current path is in the user's accessibleRoutes
	const hasAccess = accessibleRoutes.some((route) => currentPath.startsWith(route));

	if (hasAccess) {
		return <Outlet />;
	} else {
		// If the user is authenticated but doesn't have access to this route,
		// redirect them to an unauthorized page.
		return <Navigate to="/admin/unauthorized" replace />;
	}
};

export default ProtectedRoutes;
